import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import BienvenidaXpert from './components/BienvenidaXpert'; // Importa el componente de bienvenida
import { applyDefaultThemeForRubro, applyStoredTheme } from './theme/palette';


const domain = "dev-i4ndxhhmhmbyd4tt.us.auth0.com"; //auth0 propio expertcontperu@gmail.com

//Version Local
//const clientId = "sRVhE9SzcBOGmeDSncrECCLuGA88O8FQ"; //auth0 propio expertcontperu@gmail.com

//Version Web Ralwaiy
//const clientId = "cVGIEcCJEINGNoLG9khMuXeErdZ3C8jm"; //auth0 propio expertcontperu@gmail.com

//Version Web expertcont.pe
const clientId = "vFKcLZ6SHdwEWUWrMzkty0PDVjLbTZrW"; //auth0 propio expertcontperu@gmail.com

const root = ReactDOM.createRoot(document.getElementById('root'));

applyStoredTheme();

function Main() {
  // Define un estado para controlar si se muestra la pantalla de bienvenida o la aplicación principal.
  const [showApp, setShowApp] = React.useState(false);
  const [idAnfitrion, setIdAnfitrion] = React.useState(null);
  const [idInvitado, setIdInvitado] = React.useState(null);
  const [rubro, setRubro] = React.useState(sessionStorage.getItem('rubro_trabajo') || 'COMERCIAL');
  const [superUsuario, setSuperUsuario] = React.useState(sessionStorage.getItem('super') || '0');
  const [supervisorUsuario, setSupervisorUsuario] = React.useState(sessionStorage.getItem('supervisor') || '0');

  // Función para cambiar al contenido de la aplicación principal
  const startApp = (usuario, invitado, rubroUsuario = 'COMERCIAL', superAcceso = '0', supervisorAcceso = '0') => {
    const rubroFinal = rubroUsuario || 'COMERCIAL';
    setIdAnfitrion(usuario);
    setIdInvitado(invitado);
    setRubro(rubroFinal);
    setSuperUsuario(superAcceso || '0');
    setSupervisorUsuario(supervisorAcceso || '0');
    sessionStorage.setItem('rubro_trabajo', rubroFinal);
    sessionStorage.setItem('super', superAcceso || '0');
    sessionStorage.setItem('supervisor', supervisorAcceso || '0');
    applyDefaultThemeForRubro(rubroFinal);
    setShowApp(true);
  };

  return (
    <React.StrictMode>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          //redirect_uri: "http://localhost:3000"
          //redirect_uri: "https://expertcont.up.railway.app/"
          //verifica conexion
          redirect_uri: "https://expertcont.pe/"  //VERSION WEB FINAL
        }}
      >
        {/* Renderiza la pantalla de bienvenida o la aplicación principal según el estado */}
        {showApp ? (
          <App idAnfitrion={idAnfitrion} idInvitado={idInvitado} rubro={rubro} super={superUsuario} supervisor={supervisorUsuario} />
        ) : (
          <BienvenidaXpert onStartClick={startApp} />
        )}
      </Auth0Provider>
    </React.StrictMode>
  );
}

root.render(
  <Main />,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
